export const changeColorBrightness = (color: any, brightness: number) => {
  const brightnessVal = brightness / 100;
  return brightnessVal >= 0.7
    ? color.darken(brightnessVal - (1 - brightnessVal))
    : color.lighten(1 - brightnessVal * 2);
};
